module.exports = __webpack_public_path__ + "static/media/community-dg.076410f8.svg";